import React, { useEffect, useState } from "react";
import FormField from "./FormField";
import { useFormikContext } from "formik";
import { ServiceCategories, VendorServiceCounties } from "../../../service";

const Step2 = ({ fields }) => {
  const { errors, touched, values } = useFormikContext();

  // Dynamic service categories
  const [serviceOptions, setServiceOptions] = useState([]);
  const [countyOptions, setCountyOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setLoading(true);
      setLoadError(null);
      try {
        const [categoriesRes, countiesRes] = await Promise.all([
          ServiceCategories.list(),
          VendorServiceCounties.list(),
        ]);

        // Map service categories: [{ id, key, name }, ...]
        const categories = Array.isArray(categoriesRes?.data) ? categoriesRes.data : [];
        const categoryOpts = categories.map((it) => ({ value: it.id, label: it.name }));

        // Map counties: [{ id, name }, ...]
        const counties = Array.isArray(countiesRes?.data) ? countiesRes.data : [];
        const countyOpts = counties.map((it) => ({ value: it.id, label: it.name }));

        if (isMounted) {
          setServiceOptions(categoryOpts);
          setCountyOptions(countyOpts);
        }
      } catch (e) {
        console.error("Failed to load options", e);
        if (isMounted) setLoadError("Failed to load categories or counties");
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="grid grid-cols-1 justify-center md:gap-4 gap-2 w-full mt-4">
      {Object.values(fields).map((field) => {
        // Conditional visibility logic
        if (field.name === "prior_names" && values.operated_under_other_names !== "yes") return null;
        if (field.name === "partnership_type" && values.organization_type !== "PARTNERSHIP") return null;
        if (field.name === "organization_other_description" && values.organization_type !== "OTHER") return null;
        if (field.name === "organization_state" && !values.organization_type) return null;
        if (field.name === "ownership_changes_details" && values.ownership_changes_past_year !== "yes") return null;

        const isServiceField = field.name === "service_category_ids";
        const isCountyField = field.name === "county_ids";

        let fieldProps = field;

        if (isServiceField) {
          fieldProps = {
            ...field,
            options: serviceOptions,
            placeholder: loading
              ? "Loading categories..."
              : field.placeholder || "Select categories",
          };
        } else if (isCountyField) {
          fieldProps = {
            ...field,
            options: countyOptions,
            placeholder: loading
              ? "Loading counties..."
              : field.placeholder || "Select counties",
          };
        }

        return (
          <FormField
            key={field.name}
            {...fieldProps}
            error={errors[field.name]}
            touched={touched[field.name]}
          />
        );
      })}
      {/* Optional lightweight error message */}
      {loadError && (
        <div className="text-xs text-red-600">{loadError}</div>
      )}
    </div>
  );
};

export default Step2;
